import "./SpeechBubble.scss";

function SpeechBubble({ text = "喵！", position = "top", align = "center" }) {
    return <div className={`speech-bubble speech-bubble--${position} speech-bubble--${align}`}>{text}</div>;
}

export default SpeechBubble;
